import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { Col } from "@/app/components/lib/my-bootstrap";
import { useTranslation } from "@/hooks/localization/useTranslations";

type TProps = {
  onCheckOut: () => void;
  isMobile: boolean;
  onContinueShopping: () => void;
};

const CartCheckoutSection: React.FC<TProps> = ({
  isMobile,
  onCheckOut,
  onContinueShopping,
}) => {
  const t = useTranslation();
  return (
    <>
      <Col className="p-0">
        <CustomButton
          type={BtnTypes.primary}
          size={BtnSizes.large}
          radius={BtnRadius.small}
          onClick={onCheckOut}
          fullWidth
        >
          {t.checkout}
        </CustomButton>
      </Col>
      {!isMobile && (
        <Col className="p-0">
          <CustomButton
            type={BtnTypes.neutral}
            size={BtnSizes.large}
            radius={BtnRadius.small}
            onClick={onContinueShopping}
            fullWidth
          >
            {t.continue_shopping}
          </CustomButton>
        </Col>
      )}
    </>
  );
};

export default CartCheckoutSection;
